import { useState } from "react";
import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function HeroSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);
  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);

  return (
    <section id="kv" className="relative h-[600px] md:h-[800px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat pointer-events-none"
        style={{
          backgroundImage: "url('/images/kv-main.jpg')",
        }}
      />

      <div
        ref={ref}
        className={`relative z-10 h-full flex items-center transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="w-full px-4 md:px-8 lg:px-16">
          <div className="max-w-4xl mx-auto text-center">
            <div className="mb-8">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-black text-white leading-tight drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">
                <span className="block">質の高い業務で安全・安心をお届けする</span>
                <span className="block mt-2">警備のプロフェッショナル</span>
              </h1>
            </div>

            <p className="text-base md:text-xl text-white/90 mb-8 font-medium drop-shadow-[0_1px_4px_rgba(0,0,0,0.7)]">
              大阪府公安委員会認定｜交通誘導・高速道路・イベント・施設警備
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 font-bold text-base md:text-lg px-8 py-4 rounded-full whitespace-nowrap"
                onMouseEnter={() => setHovered1(true)}
                onMouseLeave={() => setHovered1(false)}
                style={{
                  backgroundColor: hovered1 ? '#c9a84c' : 'rgba(31,41,55,0.9)',
                  color: hovered1 ? '#1a2a4a' : 'white',
                  transition: 'background-color 0.3s, color 0.3s',
                }}
              >
                警備のご依頼・お見積もり
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/recruit"
                className="inline-flex items-center justify-center gap-2 font-bold text-base md:text-lg px-8 py-4 rounded-full whitespace-nowrap"
                onMouseEnter={() => setHovered2(true)}
                onMouseLeave={() => setHovered2(false)}
                style={{
                  backgroundColor: hovered2 ? '#c9a84c' : 'rgba(31,41,55,0.9)',
                  color: hovered2 ? '#1a2a4a' : 'white',
                  transition: 'background-color 0.3s, color 0.3s',
                }}
              >
                採用情報を見る
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 w-10">
        <div className="animate-bounce">
          <div className="w-10 h-10 rounded-full bg-gold text-navy flex items-center justify-center">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-line"></i>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}